import React from 'react';
import PropTypes from 'prop-types';

const MenuItemHeader = ({
    label,
    bold
}) => {
    return (
        <li>
            <div
                className="indent-1 pt-3 pb-2">
                {bold ? (
                    <strong 
                        className="pl-3">
                        {label}
                    </strong>
                ) : (
                    <div
                        className="pl-3">
                        {label}
                    </div>
                )}
            </div>
        </li>
    );
};

MenuItemHeader.defaultProps = {
    bold: false
};

MenuItemHeader.propTypes = {
    bold: PropTypes.bool,
    label: PropTypes.node
};

export default MenuItemHeader;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/site-header/dropdown-menu-item-header.jsx